// Data context provided by AdminApp once the snapshot is loaded.
import { createContext, useContext, type ReactNode } from 'react';
import type { AdminDashboardResult } from '../../../lib/adminApi';

export interface AdminContextValue {
  data: AdminDashboardResult;
  /** The verified admin password — passed through so lazy screens (e.g. league
   *  detail) can run their own callable without re-prompting. */
  password: string;
  isFetching: boolean;
  refetch: () => void;
  lock: () => void;
}

const AdminContext = createContext<AdminContextValue | null>(null);

export function AdminProvider({ value, children }: { value: AdminContextValue; children: ReactNode }) {
  return <AdminContext.Provider value={value}>{children}</AdminContext.Provider>;
}

export function useAdminData(): AdminContextValue {
  const ctx = useContext(AdminContext);
  if (!ctx) throw new Error('useAdminData must be used inside AdminProvider');
  return ctx;
}
